export const user_query = () => (
  `user {
    id
    rentalOverviewPath
    salesOverviewPath
    advertOwnersResponseTimeSentence(locale: ${I18n.locale})
    createdYear
    hasCoronaPolicy
    allowYoutube
    image {
      exists
      url(crop:"square_thumb")
    }
    averageRentalRating {
      rating
      count
    }
  }
`)

export const assets_query = () => (
  `assets(assets: $assets) {
    identifier
    url
  }`
)

